export const gameArray = [
    
    {
        name: "Купить Божественные сферы Path of Exile",
        label: "Path of Exile",
        path: 'path-of-exile',
        server: [
            {
                name: "(PC) Standard Божественные сферы",
                rate: 0.67
            },
            {
                name: "(PC) Mirage Божественные Сферы",
                rate: 0.35
            },
            {
                name: "(PC) Mirage (Hardcore) Божественные сферы",
                rate: 0.05
            },
            {
                name: "(PC) Mirage Сфера Хаоса",
                rate: 24
            }
        ],
        logo: 'path_of_exile.png',
        about: "Path of Exile - это многопользовательская онлайн-игра в жанре экшн-RPG, разработанная и изданная компанией Grinding Gear Games. Игра была выпущена в 2013 году и доступна на различных платформах, включая ПК, Mac, PlayStation и Xbox. В Path of Exile игроки могут исследовать огромный открытый мир, сражаться с монстрами и другими игроками, а также улучшать свои навыки и экипировку. Игра известна своей глубокой системой развития персонажей и сложной экономической системой."

    },
    {
        name: "Купить Золото Diablo 4",
        label: "Diablo 4",
        path: 'diablo-4',
        server: [
            {
                name: "Season of Reckoning",
                rate: 5444625
            },
            {
                name: "Season of Reckoning (Hardcore)",
                rate: 330250
            },
            {
                name: "Eternal Realm",
                rate: 70906625
            },
            {
                name: "Eternal Hardcore",
                rate: 7622500
            }
        ],
        logo: 'diablo_4.png',
        about: "Diablo 4 - это многопользовательская онлайн-игра в жанре экшн-RPG, разработанная и изданная компанией Blizzard Entertainment. Игра была выпущена в 2023 году и доступна на различных платформах, включая ПК, PlayStation и Xbox. В Diablo 4 игроки могут исследовать огромный открытый мир, сражаться с монстрами и другими игроками, а также улучшать свои навыки и экипировку. Игра известна своей глубокой системой развития персонажей и сложной экономической системой."

    },
    {
        name: "Купить Серебро Albion online",
        label: "Albion online",
        path: 'albion',
        server: [
            {
                name: "Европа (Амстердам)",
                rate: 31000
            },
            {
                name: "Америка (Вашингтон)",
                rate: 29100
            }
        ],
        exc: 319,
        logo: 'albion.png',
        about: "Albion Online - это многопользовательская онлайн-игра в жанре фэнтези, разработанная и изданная компанией Sandbox Interactive. Игра была выпущена в 2017 году и доступна на различных платформах, включая ПК, Mac, iOS и Android. В Albion Online игроки могут исследовать открытый мир, заниматься ремеслом, сражаться с монстрами и другими игроками, а также строить свои собственные города и гильдии. Игра известна своей экономической системой, которая позволяет игрокам торговать ресурсами и предметами между собой."
    },
    {
        name: "Купить Юани Perfect World",
        label: "Perfect World",
        path: 'perfect-world',
        server: [
            {
                name: "Алькор",
                rate: 53000
            },
            {
                name: "Мицар",
                rate: 48000
            },
            {
                name: "Просперо",
                rate: 75000
            },
            {
                name: "Центавр",
                rate: 53500
            },
            {
                name: "(EU) Dawnglory",
                rate: 75000
            }
        ],
        logo: 'perfect_world.png',
        about: "Perfect World - это многопользовательская онлайн-игра в жанре фэнтези, разработанная и изданная компанией Perfect World Entertainment. Игра была выпущена в 2005 году и доступна на различных платформах, включая ПК. В Perfect World игроки могут исследовать огромный открытый мир, сражаться с монстрами и другими игроками, а также улучшать свои навыки и экипировку. Игра известна своей глубокой системой развития персонажей и сложной экономической системой."
    },
    {
        name: "Купить Монеты FC 27",
        label: "FC 27",
        path: 'fc-27',
        server: [
            {
                name: "EA SPORTS FC 27 (PC)",
                rate: 508
            },
            {
                name: "EA SPORTS FC 27 (PS)",
                rate: 618
            },
            {
                name: "EA SPORTS FC 27 (XBOX)",
                rate: 618
            },
        ],
        logo: 'fc_26.png',
        about: "EA SPORTS FC 27 - это многопользовательская онлайн-игра в жанре спортивного симулятора, разработанная и изданная компанией EA Sports. Игра была выпущена в 2023 году и доступна на различных платформах, включая ПК, PlayStation и Xbox. В EA SPORTS FC 26 игроки могут участвовать в футбольных матчах, улучшать свои навыки и команды, а также соревноваться с другими игроками в онлайн-режимах."

    },
    {
        name: "Купить Караты Karos Online",
        label: "Karos Online",
        path: 'karos-online',
        server: [
            {
                name: "Арис",
                rate: 29500
            },
            {
                name: "Аурион",
                rate: 23500
            },
            {
                name: "Шурадан-Камнешрам",
                rate: 42700
            },
            {
                name: "Герот",
                rate: 39600
            }
        ],
        logo: 'karos.png',
        about: "Karos Online - это многопользовательская онлайн-игра в жанре фэнтези, разработанная и изданная компанией MAIET Entertainment. Игра была выпущена в 2007 году и доступна на различных платформах, включая ПК. В Karos Online игроки могут исследовать огромный открытый мир, сражаться с монстрами и другими игроками, а также улучшать свои навыки и экипировку. Игра известна своей глубокой системой развития персонажей и сложной экономической системой."
    },
    {
        name: "Купить Крышки Fallout 76",
        label: "Fallout 76",
        path: 'fallout-76',
        server: [
            {
                name: "PlayStation",
                rate: 40
            },
            {
                name: "Xbox",
                rate: 30
            }
        ],
        logo: 'fallout_76.png',
        about: "Fallout 76 - это многопользовательская онлайн-игра в жанре ролевого экшена, разработанная и изданная компанией Bethesda Game Studios. Игра была выпущена в 2018 году и доступна на различных платформах, включая ПК, PlayStation и Xbox. В Fallout 76 игроки могут исследовать огромный открытый мир, сражаться с монстрами и другими игроками, а также улучшать свои навыки и экипировку. Игра известна своей глубокой системой развития персонажей и сложной экономической системой."
    },
    {
        name: "Купить Золото Lost Ark",
        label: "Lost Ark",
        path: 'lost-ark',
        server: [
            {
                name: "(RU) Альдеран",
                rate: 180
            },
            {
                name: "(RU) Кратос",
                rate: 182
            },
            {
                name: "(RU) Процей",
                rate: 8
            }
        ],
        logo: 'lost_ark.png',
        about: "Lost Ark - это многопользовательская онлайн-игра в жанре экшн-RPG, разработанная и изданная компанией Smilegate. Игра была выпущена в 2018 году и доступна на различных платформах, включая ПК. В Lost Ark игроки могут исследовать огромный открытый мир, сражаться с монстрами и другими игроками, а также улучшать свои навыки и экипировку. Игра известна своей глубокой системой развития персонажей и сложной экономической системой."
    },
    {
        name: "Купить Золото RuneScape",
        label: "RuneScape",
        path: 'runescape',
        server: [
            {
                name: "RuneScape",
                rate: 365000
            },
            {
                name: "Old School RuneScape",
                rate: 42300
            }
        ],
        logo: 'runescape.png',
        about: "RuneScape - это многопользовательская онлайн-игра в жанре фэнтези, разработанная и изданная компанией Jagex. Игра была выпущена в 2001 году и доступна на различных платформах, включая ПК, Mac и мобильные устройства. В RuneScape игроки могут исследовать огромный открытый мир, сражаться с монстрами и другими игроками, а также улучшать свои навыки и экипировку. Игра известна своей глубокой системой развития персонажей и сложной экономической системой."
    },
    {
        name: "Купить Золото Corepunk",
        label: "Corepunk",
        path: 'corepunk',
        server: [
            {
                name: "EU",
                rate: 5
            },
            {
                name: "US",
                rate: 3
            }
        ],
        logo: 'corepunk.png',
        about: "Corepunk - это многопользовательская онлайн-игра в жанре экшн-RPG, разработанная и изданная компанией Artificial Core. Игра была выпущена в 2023 году и доступна на различных платформах, включая ПК. В Corepunk игроки могут исследовать огромный открытый мир, сражаться с монстрами и другими игроками, а также улучшать свои навыки и экипировку. Игра известна своей глубокой системой развития персонажей и сложной экономической системой."
    },
    {
        name: "Купить Золото Last Epoch",
        label: "Last Epoch",
        path: 'last-epoch',
        server: [
            {
                name: "Beneath Ancient Skies (Standard)",
                rate: 20000
            },
            {
                name: "Tombs of the Erased (Standard)",
                rate: 51000
            },
            {
                name: "Legacy (Standard)",
                rate: 275000
            }
        ],
        logo: 'last_epoch.png',
        about: "Last Epoch - это многопользовательская онлайн-игра в жанре экшн-RPG, разработанная и изданная компанией Eleventh Hour Games. Игра была выпущена в 2019 году и доступна на различных платформах, включая ПК. В Last Epoch игроки могут исследовать огромный открытый мир, сражаться с монстрами и другими игроками, а также улучшать свои навыки и экипировку. Игра известна своей глубокой системой развития персонажей и сложной экономической системой."
    }
]